export default 'https://tme.understood.org/assets/bundle_1.7374f9cb.vtt'